module.exports = __webpack_public_path__ + "static/img/Gallery02.34ff8e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls46-1/Gallery02.jpg
// module id = xWor
// module chunks = 12